import { asBooleanWithDefault, detectFeatureToggles } from '@rio-cloud/rio-uikit/urlFeatureToggles';
import { addBreadcrumbToSentry } from '../setup/sentry';

// Define old toggles to clean up the local storage state
const cleanupStateForOldToggles: string[] = [
    'ft_tableSettings',
    'ft_to_excel_export',
    'ft_pickup',
    'ft_to_bulk',
    'ft_new_service_option_execution_api',
];

export const clientSideFeatureToggles = detectFeatureToggles(
    {
        enableConsoleTracing: asBooleanWithDefault('ft_enable_console_tracing', false),
    },
    cleanupStateForOldToggles,
);

addBreadcrumbToSentry({
    category: 'features',
    level: 'info',
    message: 'query parameter feature toggles',
    data: clientSideFeatureToggles,
});
